import { useMutation } from '@tanstack/react-query';
import { getScreenComponent, convertScreenComponent } from '../../../../api';
import type { IScreensComponent } from '../../../../api';
import type { ILogging } from '../../../../api/types';

interface LoadMoreParams {
  screenName: string;
  componentId: number;
  screenLogging?: ILogging;
  queryParams: Record<string, string>;
}

/**
 * 캐러셀 load-more 페이지 요청. 기존 component 엔드포인트를 그대로 재사용하며
 * `next_token`을 queryParam으로 전달한다. mutationFn은 단일 API 요청 + 응답
 * 변환만 수행하고, append/종료 분기는 useGoodsCarouselLoadMore가 담당한다.
 */
export const useScreenComponentLoadMore = () =>
  useMutation({
    mutationFn: ({
      screenName,
      componentId,
      screenLogging,
      queryParams,
    }: LoadMoreParams): Promise<IScreensComponent> =>
      getScreenComponent({ screenName, componentId, queryParams }).then(raw =>
        convertScreenComponent(raw, screenLogging ?? {}),
      ),
  });
